














import {
  AppCustomerViewQuery,
  AppCustomerViewQuery_customers_items,
} from '@/features/app-customer/views/customer/__generated__/AppCustomerViewQuery';
import { APOLLO_CLIENT } from '@/features/core/container/model';
import { defineComponent } from '@vue/composition-api';
import query from '@/features/app-customer/views/customer/view.gql';
import getTreeNodeCustomerIdQuery from '@/features/app-heating-system/views/tree-node/get-tree-node-customer-id.gql';
import {
  GetTreeNodeCustomerId,
  GetTreeNodeCustomerIdVariables,
} from '@/features/app-heating-system/views/tree-node/__generated__/GetTreeNodeCustomerId';
import { mapGetters } from 'vuex';

type Customer = AppCustomerViewQuery_customers_items;

export default defineComponent({
  data(): {
    isLoading: boolean;
    selectedCustomer: Customer | null;
    customers: Customer[];
  } {
    return {
      isLoading: false,
      selectedCustomer: null,
      customers: [] as AppCustomerViewQuery['customers']['items'],
    };
  },

  computed: {
    ...mapGetters(['activeTreeNodeId']),
  },

  watch: {
    selectedCustomer(customer: Customer) {
      this.$emit('customer-updated', customer);
    },
  },
  mounted() {
    this.fetchCustomers();
  },
  methods: {
    async fetchCustomers(): Promise<void> {
      try {
        this.isLoading = true;

        if (!this.activeTreeNodeId) {
          return;
        }
        const firstResult = await this.$apollo.query<GetTreeNodeCustomerId, GetTreeNodeCustomerIdVariables>({
          client: APOLLO_CLIENT.PORTAL_CLIENT,
          query: getTreeNodeCustomerIdQuery,
          variables: {
            id: this.activeTreeNodeId,
          },
          fetchPolicy: 'no-cache', // ✅ prevents cache conflicts
        });

        // Optional: Extract customer directly
        const treeNodeCustomer = firstResult.data.treeNodes.first?.customer;

        const { data } = await this.$apollo.query<AppCustomerViewQuery>({
          client: APOLLO_CLIENT.PORTAL_CLIENT,
          query,
        });
        this.customers = data.customers.items;
        // Check if activeTreeNodeId is in the list
        if (this.activeTreeNodeId) {
          const match = this.customers.find((c) => c.id === treeNodeCustomer.id);
          if (match) {
            this.selectedCustomer = match;
          }
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
});
